import React from 'react'
import styles from './DateTimeInput.module.scss'

interface DateTimeInputProps {
  id?: string
  value: string
  onChange: (value: string) => void
  disabled?: boolean
  error?: boolean
  className?: never
}

export const DateTimeInput: React.FC<DateTimeInputProps> = ({
  id, value, onChange, disabled = false, error = false,
}) => (
  <input
    id={id}
    type="datetime-local"
    value={value}
    onChange={(e) => onChange(e.target.value)}
    disabled={disabled}
    className={[styles.input, error ? styles.error : ''].filter(Boolean).join(' ')}
  />
)
